import React from 'react';
import NewIngestCredentialsView from './NewIngestCredentialsView';

export default function NewIngestCredentialsContainer(props: any) {
    const {
        isCredentialsShown,
        passwordField,
        userNameField,
    } = props;
    
    if (!isCredentialsShown)
        return null;
    
    return (
        <NewIngestCredentialsView
            passwordField={passwordField}
            userNameField={userNameField}
        />
    );
}

